import { generateGradientAreaStyleOfAreableLineChart } from '@/pages/intelligence/utils/echartsUtils';
import { isEmpty, getSortedDates } from '@/pages/intelligence/utils/commonUtils';

import type { ICommonFlagMap } from '@/pages/intelligence/types/common';
import type { IEChartDynamicOption, IEChartSeriesOption } from '@/pages/intelligence/types/echart';
import type { IStoreRankDetailsVisualisSourceData } from '@/pages/intelligence/types/storeRank';

function getIsOnlyOneDotThisSerie(
  sourceData: IStoreRankDetailsVisualisSourceData[],
  sourceDataDimension: string,
): boolean {
  if (!Array.isArray(sourceData)) return false;
  let num = 0;
  for (const sourceDataItem of sourceData) {
    if (sourceDataItem && !isEmpty(sourceDataItem[sourceDataDimension])) {
      num = num + 1;
      if (num > 1) break;
    }
  }
  return num === 1;
}

export function getEChartDynamicLineChartOption(option?: {
  isAreaEChart: boolean;
  sourceData: IStoreRankDetailsVisualisSourceData[];
  sourceDataDimensions: string[];
}): IEChartDynamicOption {
  const sourceData = option?.sourceData;
  const sourceDataDimensions = option?.sourceDataDimensions;
  const isAreaEChart = option?.isAreaEChart;
  const dynamicOption: IEChartDynamicOption = {
    xAxis: {
      data: [],
    },
    series: [],
    dataset: {
      dimensions: ['date'],
      source: [],
    },
  };
  const datesMap: ICommonFlagMap = {};
  const dimensionsMap: ICommonFlagMap = {};
  let baseLineSerie: IEChartSeriesOption = isAreaEChart
    ? {
        type: 'line',
        showSymbol: false,
        symbol: 'circle',
        symbolSize: 8,
        stack: 'Total',
        smooth: true,
        emphasis: {
          focus: 'series',
        },
      }
    : {
        type: 'line',
        showSymbol: false,
        symbol: 'circle',
        symbolSize: 8,
        smooth: false,
        emphasis: {
          focus: 'series',
        },
      };

  if (!Array.isArray(sourceData)) return dynamicOption;
  if (!Array.isArray(sourceDataDimensions)) return dynamicOption;

  for (let i = 0; i < sourceDataDimensions.length; i++) {
    const sourceDataDimension = sourceDataDimensions[i];
    if (!sourceDataDimension) continue;
    if (!dimensionsMap[sourceDataDimension]) {
      if (isAreaEChart) {
        baseLineSerie = {
          ...baseLineSerie,
          // 面积图、或者面积图只有一个点的时候需要显示圆点
          showSymbol: getIsOnlyOneDotThisSerie(sourceData, sourceDataDimension),
          areaStyle: generateGradientAreaStyleOfAreableLineChart(i),
        };
      }

      dynamicOption.dataset.dimensions.push(sourceDataDimension);
      dynamicOption.series.push({
        ...baseLineSerie,
        name: sourceDataDimension,
      });
      dimensionsMap[sourceDataDimension] = true;
    }
  }

  for (const sourceDataItem of sourceData) {
    const date = sourceDataItem?.date;
    if (!date) continue;
    if (!datesMap[date]) {
      dynamicOption.xAxis.data.push(date);
      dynamicOption.dataset.source.push(sourceDataItem);
      datesMap[date] = true;
    }
  }

  dynamicOption.xAxis.data = getSortedDates(dynamicOption.xAxis.data, 'asc');

  return dynamicOption;
}
